<app-access-item [icon]="icon()" [iconColor]="iconColor()" [hideOverflow]="true">
  <app-access-item-header>
    <span>Password</span>
    <app-upgrade-badge location="public-password-item" scope="gallery:password"></app-upgrade-badge>
  </app-access-item-header>
  <app-access-item-cta>
    <label for="gallery-password" class="save-toggle">
      <app-switch
        [noInteraction]="
          (!('gallery:password' | billingScope) && !gallery().password_enabled) || !galleryPermissions().can_edit
        "
        [smallish]="true"
      >
        <input
          type="checkbox"
          id="gallery-password"
          [(ngModel)]="showPassword"
          (ngModelChange)="toggleGalleryPassword()"
          [disabled]="
            (!('gallery:password' | billingScope) && !gallery().password_enabled) || !galleryPermissions().can_edit
          "
        />
        <label for="gallery-password"></label>
      </app-switch>
    </label>
  </app-access-item-cta>
</app-access-item>

@if (showPassword()) {
  @if (!editingPassword()) {
    <div class="add-password-form">
      <app-input-field [noLabel]="true" [smallNoLabel]="true" [noLabelExtraSpacing]="true" class="headless">
        <div fake-input [class.disabled]="!galleryPermissions().can_edit">• • • • • • • • •</div>

        <div *appInputPost class="password-actions">
          @if (galleryPermissions().can_edit) {
            <button
              appButton
              name="edit-password"
              location="public-password-item"
              [iconButton]="true"
              color="simple-gray"
              shape="round"
              height="0"
              (click)="editingPassword.set(true)"
              class="edit-gallery-button"
            >
              <app-svg src="/assets/icons/edit.svg" size="0"></app-svg>
            </button>
          }

          <button
            appButton
            type="button"
            name="copy-password"
            location="public-password-item"
            color="primary"
            spacing="3"
            size="0-5"
            height="0"
            weight="bold"
            shape="round"
            [copy-clipboard]="gallery().password"
            (click)="onPasswordCopied()"
          >
            Copy
          </button>
        </div>
      </app-input-field>
    </div>
  } @else {
    <form [formGroup]="passwordForm" (ngSubmit)="savePassword()" class="add-password-form">
      <div class="field-and-button">
        <app-input-field
          [control]="passwordForm.controls.password"
          [noLabel]="true"
          [smallNoLabel]="true"
          [noLabelExtraSpacing]="true"
        >
          <input type="text" formControlName="password" placeholder="Password" appAutofocus />
        </app-input-field>
        <button
          appButton
          type="button"
          name="save-password"
          location="public-password-item"
          color="primary"
          spacing="3"
          size="1"
          weight="bold"
          (click)="savePassword()"
        >
          Save
        </button>
      </div>
    </form>
  }
}
